import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { connect } from "react-redux";
import { isIOS } from 'mobile-device-detect';

import '../../styles/ApplicationStep.css';
import BackButton from './buttons/BackButton';
import HamburgerButton from './buttons/HamburgerButton';

import Drawer, {
    DrawerContainer,
    MainContentContainer,
} from 'react-swipeable-drawer';

import DrawerContent from '../profile/DrawerContent';
import { ARABIC } from '../../../utils/Constants';

class ApplicationStep extends Component {

    constructor(props) {
        super(props);

        this.renderContent = this.renderContent.bind(this);
        this.handleToggleDrawer = this.handleToggleDrawer.bind(this);
        this._prevDrawerOpen = false;
        this._lastNotifiedDrawerOpen = null;
    }

    componentDidUpdate() {
        if (this._scheduleDrawerContainerClass) {
            this._scheduleDrawerContainerClass = false;
            const el = document.querySelector('.DrawerContainer');
            if (el) {
                if (this._drawerOpen) {
                    el.classList.add('open');
                } else {
                    el.classList.remove('open');
                }
            }
        }
    }

    renderHeader(toggleDrawer, drawerOpen = false) {
        let headerId, textProp, drawerColor;
        const { buttonsFont, fontFamilyType } = this.props.customerThemes.selectedTheme;
        headerId = this.props.transparentHeader ? 'headerContainerTransparent' : 'headerContainer';
        textProp = this.props.text ? this.props.text : null;
        const isArabic = this.props.language === ARABIC;
        //const showName = this.props.showTransparentHeaderBrandName === true;
        const headerSolid = this.props.transparentHeaderSolid === true;
        const headerClassName = (this.props.transparentHeader && headerSolid) ? 'header-at-top' : '';
        // const nameStyle = {
        //     color: buttonsFont,
        //     fontFamily: fontFamilyType,
        //     //display: showName ? 'block' : 'none',
        //     ...(showName && { textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' })
        // };

        return (
            <div
                dir="ltr"
                id={headerId}
                className={headerClassName}
                style={this.props.isLoadedFromCheckout || window.location.hash.includes('/product/') ? { position: 'fixed', zIndex: 100 } : null}
                onClick={(e) => {
                    /* iOS: header sits over top of banner (fixed, z-index); taps on that band hit the header, not the drawer overlay. Close drawer when tapping header outside #drawerMenu while open. */
                    if (isIOS && !e.target.closest('#drawerMenu')) {
                        if (drawerOpen && this.props.userOnline) toggleDrawer();
                        e.stopPropagation();
                    }
                    if (!isIOS && !e.target.closest('#drawerMenu')) e.stopPropagation();
                }}
            >
                {this.props.hideBackButton ? <div style={{ width: '10%' }} /> : <BackButton goBack={this.props.goBack} isShadowed={this.props.isHamburgerShadowed} color={buttonsFont} />}
                {
                    this.props.switchLanguageButtons ?
                        <div className="languageButtonWrapper">{this.props.switchLanguageButtons}</div> : null
                }
                <div id="headerText">
                    <div dir={isArabic ? "rtl" : "ltr"} id="restAndBrandName">
                        {textProp}
                    </div>
                </div>
                <div
                    id="drawerMenu"
                    style={{ color: this.props.drawerColor }}
                    onClick={!isIOS ? () => this.handleToggleDrawer(toggleDrawer) : undefined}
                >
                    <HamburgerButton
                        isShadowed={this.props.isHamburgerShadowed}
                        isMainScreen={this.props.isMainScreen}
                        color={buttonsFont}
                        onClick={isIOS ? (e) => {
                            e.stopPropagation();
                            this.handleToggleDrawer(toggleDrawer);
                        } : undefined}
                    />
                </div>
                {/* Surgical inert: only the header region that overlaps the cart (sticky bar row). Set proactively so the tap registers on the cart, not the header. Never inert the whole header (would lose hamburger). */}
                {this.props.headerCartPassThrough ? (
                    <div
                        className="headerCartPassThrough"
                        ref={el => { if (el) el.setAttribute('inert', ''); }}
                        style={isArabic ? {
                            position: 'absolute',
                            top: 50,
                            left: 0,
                            width: 56,
                            height: 62,
                            pointerEvents: 'none',
                        } : {
                            position: 'absolute',
                            top: 50,
                            right: 0,
                            width: 56,
                            height: 62,
                            pointerEvents: 'none',
                        }}
                    />
                ) : null}
            </div>
        );
    }

    handleToggleDrawer(toggleDrawer) {
        if (this.props.userOnline) toggleDrawer();
    }

    renderContent() {
        let contetnId = this.props.transparentHeader ? 'contentContainerTransparent' : 'contentContainer';
        const { menuItemsBackground } = this.props.customerThemes.selectedTheme;

        return (
            <div id={contetnId} style={this.props.isLoadedFromCheckout ? { overflow: 'unset', paddingTop: '60px', backgroundColor: menuItemsBackground } : { backgroundColor: menuItemsBackground }}>
                {this.props.content}
            </div>
        );
    }

    renderFooter() {
        return (
            <div id="footerContainer">
                {this.props.renderFooter()}
            </div>
        );
    }

    render() {
        const { type, menuBackground } = this.props.customerThemes.selectedTheme;

        let applicationStepEl = document.getElementById('applicationStep');

        // if (applicationStepEl) {
        //     applicationStepEl.style.backgroundColor = type === 'CUSTOM' || 'DARK' || 'LIGHT' ? menuBackground : '#fff';
        // }


        return (
            <Drawer position="right" size={80}>
                {({
                    position,
                    size,
                    swiping,
                    translation,
                    mainContentScroll,
                    toggleDrawer,
                    handleTouchStart,
                    handleTouchMove,
                    handleTouchEnd,
                }) => {
                    const isOpen = translation > 0;
                    if (this._prevDrawerOpen !== isOpen) {
                        this._scheduleDrawerContainerClass = true;
                        this._drawerOpen = isOpen;
                    }
                    this._prevDrawerOpen = isOpen;
                    if (this.props.onDrawerOpenChange) {
                        if (this._lastNotifiedDrawerOpen === null) {
                            this._lastNotifiedDrawerOpen = isOpen;
                        } else if (this._lastNotifiedDrawerOpen !== isOpen) {
                            this._lastNotifiedDrawerOpen = isOpen;
                            const notify = () => this.props.onDrawerOpenChange(isOpen);
                            if (typeof queueMicrotask === 'function') queueMicrotask(notify);
                            else setTimeout(notify, 0);
                        }
                    }
                    return (
                    <div className={isOpen ? 'drawer-open open' : ''}>
                        <DrawerContainer
                            position={position}
                            size={size}
                            swiping={swiping}
                            translation={translation}
                            toggleDrawer={toggleDrawer}
                            handleTouchStart={handleTouchStart}
                            handleTouchMove={handleTouchMove}
                            handleTouchEnd={handleTouchEnd}
                            drawerContent={
                                <DrawerContent
                                    toggleDrawer={toggleDrawer}
                                    currentPath={window.location.href}
                                />}
                        />
                        <MainContentContainer
                            translation={translation}
                            mainContentScroll={mainContentScroll}
                        >
                            <div id="applicationStep">
                                {!this.props.hideHeader && (this.props.transparentHeader && isIOS && this.props.portalHeaderOnIOS
                                    ? ReactDOM.createPortal(
                                        <div key="menu-header-portal">{this.renderHeader(toggleDrawer, isOpen)}</div>,
                                        document.body
                                    )
                                    : this.renderHeader(toggleDrawer, isOpen))}
                                {this.props.content ? this.renderContent() : null}
                                {this.props.footer ? this.renderFooter() : null}
                            </div>
                        </MainContentContainer>
                    </div>
                    );
                }}
            </Drawer>
        );
    }
}

const mapStateToProps = state => {
    return {
        userOnline: state.userOnline,
        customerThemes: state.customerThemes,
        language: state.storeLocalStorage.language
    };
};

export default connect(mapStateToProps, null)(ApplicationStep);

